import md5 from 'js-md5'
import request from '@/utils/request'
/* 登录 */


// 登录
export function login(data) {
  return request({
    url: '/imes-uaa/oauth/token',
    method: 'post',
    headers: {
      Authorization: 'Basic bWF0ZTptYXRlX3NlY3JldA==',
    },
    params: {
      name: data.name,
      username: data.username,
      password: md5(data.password),
      grant_type: 'password',
      scope: 'all',
      parameters: 'fsf',
    },
    //getAllData: true, // 获取全部返回的数据
  })
}

// 退出登录
export function logout() {
  return request({
    url: '/imes-uaa/auth/logout',
    method: 'post',
  })
}

// 菜单树
export function tree() {
  return request({
    url: 'imes-system/menu/tree',
    method: 'get',
  })
}

// 权限列表
export function auth() {
  return request({
    url: 'imes-uaa/auth/get/user',
    method: 'get',
  })
}

// 获取公司名称及logo
export function oneImgAndName() {
  return request({
    url: 'imes-system/tenant/getOneImgAndName',
    method: 'get',
  })
}

// 获取小程序链接
export function weChatLink(params) {
  return request({
    url: 'imes-portal-web/wechat/miniprogram/urllink',
    method: 'get',
    params,
  })
}

// 获取微信扫码登录的二维码
export function webQRLogin(params) {
  return request({
    url: 'imes-system/QR-code/webQRLogin',
    method: 'get',
    params,
  })
}

// 获取微信扫码登录结果
export function scanQRCodeRes(params) {
  return request({
    url: 'imes-uaa/oauth/get-login-token',
    method: 'get',
    params,
  })
}